import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 lg:py-32 bg-brand-800 text-white relative overflow-hidden" data-id="element-59">
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-brand-700/30 rounded-full blur-[120px] pointer-events-none" data-id="element-60"></div>
      <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] bg-brand-900/40 rounded-full blur-[120px] pointer-events-none" data-id="element-61"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-63">
          <h2 className="text-4xl md:text-6xl font-serif font-medium mb-10 leading-[1.1] tracking-tight" data-id="element-64">
            El próximo lunes,{' '}
            <span className="text-accent-400" data-id="element-65">¿qué elegís?</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-brand-100/80 mb-14 leading-relaxed font-normal" data-id="element-66">
            <p data-id="element-67">Podés seguir armando clases a último momento...</p>
            <p className="font-serif font-medium text-accent-300 text-2xl md:text-3xl" data-id="element-68">
              O podés tener todo tu año de Arte resuelto.
            </p>
            <p className="font-medium text-white text-xl md:text-2xl pt-4" data-id="element-69">
              Dejá de improvisar.
            </p>
          </div>

          <button onClick={scrollToPricing} className="group w-full sm:w-auto bg-brand-500 hover:bg-brand-600 text-white text-lg font-medium py-5 px-10 rounded-2xl shadow-cta transition-colors duration-300 mb-8 inline-flex items-center justify-center gap-3 tracking-wide" data-id="element-70">
            QUIERO MI SISTEMA ARTE LISTA AHORA
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" data-id="element-71" />
          </button>

          <div className="flex items-center justify-center gap-2 text-sm text-brand-200/60 font-normal" data-id="element-72">
            <Lock className="w-4 h-4" strokeWidth={1.5} data-id="element-73" />
            Pago 100% seguro · Mercado Pago · Tarjeta · Transferencia
          </div>
        </motion.div>
      </div>
    </section>;
}